import { i18n } from "../../../plugins/i18n.js";
import locales from "../../../res/translations";

const stored = localStorage.getItem("language");
const locale = locales[stored ?? i18n.locale];

export default [
  {
    column: "U_countAsWorkingTime",
    selector: new RegExp(locale["paid"]),
    className: "green--text"
  },
  {
    column: "U_countAsWorkingTime",
    selector: new RegExp(locale["unpaid"]),
    className: "red--text"
  },
  {
    column: "U_openVacation",
    selector: /^(?!0).*$/,
    className: "blue--text"
  },
  {
    column: "U_openVacation",
    selector: /^0$/,
    className: "red--text"
  }
];
